/**
 * WebSocket URL
 */
export const WEBSOCKET_URL: string | undefined = process.env.WEBSOCKET_URL;

/**
 * Socket.IO path (optional)
 */
export const SOCKETIO_PATH: string | undefined = process.env.SOCKETIO_PATH;

/**
 * Websocket transport options (the default values are polling and websocket)
 */
export const WEBSOCKET_TRANSPORT = (process.env.WEBSOCKET_TRANSPORT ?? "polling,websocket").split(",");
